import { navigateTo } from "@/shared/utils/navigation";

/**
 * Handles navigation logic for stories page
 */

/** The stories list itself, and a folder open inside it. */
const STORIES_LIST = "/pages/editor";

/**
 * Whether the given path is the stories list rather than somewhere else in the
 * app. `/pages/editor/:storyId` is a story open in the editor, so only the bare
 * path and a folder under it count.
 */
export function isOnStoriesList(pathname: string): boolean {
  return (
    pathname === STORIES_LIST ||
    pathname === `${STORIES_LIST}/` ||
    pathname.startsWith(`${STORIES_LIST}/folder/`)
  );
}

/**
 * Navigates to folder or stories page based on folderId.
 *
 * Inside the list, opening a folder is a filter change and replaces the entry:
 * back should leave the list rather than walk out through every folder that was
 * opened. Arriving from anywhere else — the dashboard's Location cell, per node
 * 53:65218 — is a jump between pages and gets its own entry, or back cannot
 * return to where the click came from.
 */
export function navigateToFolder(
  folderId: string,
  pathname: string = window.location.pathname,
): void {
  navigateTo(folderId ? `${STORIES_LIST}/folder/${folderId}` : STORIES_LIST, {
    replace: isOnStoriesList(pathname),
  });
}
